module.exports = __webpack_public_path__ + "static/media/logo.0e0aadb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 570
// module chunks = 0